<template>
  <l-modal
    :title="t('close-delivery.subtitle')"
    :button-text="t('close-delivery.accept')"
    :full-height="false"
    @close="emit('close')"
    @action="onConfirm"
  >
    <div class="grid grid-cols-3 gap-2">
      <div
        v-for="(time, index) in Object.values(closingTimes)"
        :key="time.label"
        class="h-14 rounded-lg bg-n-700 text-n-0 flex items-center cursor-pointer justify-center font-body text-sm"
        :class="{
          'bg-v-300 ': index === selectedClosingIndex
        }"
        @click="selectedClosingIndex = index"
      >
        {{ closingTimes[index].label }}
      </div>
    </div>
    <div v-if="selectedClosingIndex === 5" class="flex items-center justify-between py-3 mt-4">
      <div>{{ t('close-delivery.custom') }}</div>
      <quantity-selector
        :min="15"
        :quantity="customQuantity"
        :step="15"
        :is-maxed="customQuantity >= 360"
        @update:quantity="
          quantity => {
            if (quantity <= 360) customQuantity = quantity
          }
        "
      >
        <template #default="{ quantity }">
          <div class="w-auto text-center mx-2">{{ quantity }} {{ t('close-delivery.min') }}</div>
        </template>
      </quantity-selector>
    </div>
  </l-modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LModal } from '@last/core-ui/paprika'

import QuantitySelector from '@/modules/ordering/QuantitySelector.vue'
import type { ClosingTime } from '@/types/virtualBrands'

const emit = defineEmits<{
  close: []
  confirm: [selectedIndex: ClosingTime]
}>()

const { t } = useI18n()

const selectedClosingIndex = ref<number | null>(null)
const customQuantity = ref(15)

const closingTimes = computed(() => [
  {
    minutes: 15,
    label: t('close-delivery.15-minutes')
  },
  {
    minutes: 30,
    label: t('close-delivery.30-minutes')
  },
  {
    minutes: 60,
    label: t('close-delivery.1-hour')
  },
  {
    minutes: 'untilClosure' as const,
    label: t('close-delivery.until-closure')
  },
  {
    minutes: 'indefinitely' as const,
    label: t('close-delivery.indefinitely')
  },
  {
    label: t('close-delivery.custom')
  }
])

function onConfirm() {
  if (selectedClosingIndex.value === null) return
  emit('confirm', closingTimes.value[selectedClosingIndex.value].minutes ?? customQuantity.value)
}
</script>
